import React, { Component } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

function LtiPlayer(props) {
	const { id } = useParams()
	const dispatch = useDispatch()
	useEffect(() => {
		dispatch(props.fetchLtiContent(id))
	}, [])

	useEffect(() => {
		if (props.content.length) {
			dispatch(props.fetchLtiContent(id))
		}

		if (props.params) {
			props.submitLtiForm(props.params, id)
		}
	}, [props.content, props.params])

	return (
		<div style={{ width: '100%', height: '100%' }}>
			<form id='ltiForm' name='ltiForm' target='ltiPlayer' method='POST' />

			<iframe
				id='ltiPlayer'
				name='ltiPlayer'
				src='about:blank'
				width='100%'
				height='98%'
				scrolling='auto'
				frameBorder='0'
				// onLoad=""
				allowFullScreen
				allow='microphone ; camera ; midi *;'
			></iframe>
		</div>
	)
}

export default LtiPlayer
